/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RestrictionCheckSummaryDTOFromJSON, RestrictionCheckSummaryDTOToJSON, } from './RestrictionCheckSummaryDTO';
/**
 * Check if a given object implements the PaginatedResponseRestrictionCheckSummaryDTO interface.
 */
export function instanceOfPaginatedResponseRestrictionCheckSummaryDTO(value) {
    return true;
}
export function PaginatedResponseRestrictionCheckSummaryDTOFromJSON(json) {
    return PaginatedResponseRestrictionCheckSummaryDTOFromJSONTyped(json, false);
}
export function PaginatedResponseRestrictionCheckSummaryDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(RestrictionCheckSummaryDTOFromJSON)),
    };
}
export function PaginatedResponseRestrictionCheckSummaryDTOToJSON(json) {
    return PaginatedResponseRestrictionCheckSummaryDTOToJSONTyped(json, false);
}
export function PaginatedResponseRestrictionCheckSummaryDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(RestrictionCheckSummaryDTOToJSON)),
    };
}
